import { fmtDate } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle, Send } from "lucide-react";

export const BookingChat = ({ bookingId, meId }) => {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  const load = async () => { try { const { data } = await api.get(`/bookings/${bookingId}/messages`); setMsgs(data); } catch {} };
  useEffect(() => {
    if (!open) return;
    load();
    const t = setInterval(load, 8000);
    return () => clearInterval(t);
  }, [open, bookingId]); // eslint-disable-line
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { const { data } = await api.post(`/bookings/${bookingId}/messages`, { text }); setMsgs((m) => [...m, data]); setText(""); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <div className="mt-4 border-t border-slate-800 pt-3" data-testid={`chat-${bookingId}`}>
      <button onClick={() => setOpen(!open)} className="eb-btn-outline !py-1.5 text-xs" data-testid={`chat-toggle-${bookingId}`}>
        <MessageCircle className="w-3.5 h-3.5" /> {open ? "Chat schließen" : "Nachrichten"}
      </button>
      {open && (
        <div className="mt-3 rounded-lg border border-slate-800 bg-[#0B0F17]">
          <div className="max-h-64 overflow-y-auto p-3 space-y-2" data-testid={`chat-messages-${bookingId}`}>
            {msgs.length === 0 && <p className="text-xs text-slate-500">Noch keine Nachrichten. Schreib die erste Nachricht.</p>}
            {msgs.map((m) => (
              <div key={m.id} className={`flex ${m.sender_id === meId ? "justify-end" : "justify-start"}`}>
                <div className={`max-w-[80%] rounded-lg px-3 py-2 text-sm ${m.sender_id === meId ? "bg-[#FF5A1F]/20 text-white" : "bg-slate-800 text-slate-200"}`} data-testid={`chat-msg-${m.id}`}>
                  <div className="text-[10px] text-slate-400 mb-0.5">{m.sender_name} · {m.created_at?.slice(11, 16)} · {fmtDate(m.created_at)}</div>
                  {m.text}
                </div>
              </div>
            ))}
            <div ref={endRef} />
          </div>
          <div className="flex gap-2 p-2 border-t border-slate-800">
            <input className="eb-input flex-1 !py-2 text-sm" placeholder="Nachricht schreiben…" value={text} onChange={(e) => setText(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && send()} data-testid={`chat-input-${bookingId}`} />
            <button onClick={send} disabled={busy || !text.trim()} className="eb-btn-primary !py-2 !px-3" data-testid={`chat-send-${bookingId}`}><Send className="w-4 h-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
};
